<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">Редагувати клієнта</h2>
    </v-card-title>

    <v-card-content>
      <div class="form">
        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.first_name" :label="$t('base.first_name')" :hint="errorMessage('first_name')"
                :focus="true" :invalid="!!errorMessage('first_name')" @input="clearFieldError('first_name')" />
            </div>
          </div>

          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.email" :label="$t('base.email')" :hint="errorMessage('email')"
                :invalid="!!errorMessage('email')" @input="clearFieldError('email')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.last_name" :label="$t('base.last_name')" :hint="errorMessage('last_name')"
                :invalid="!!errorMessage('last_name')" @input="clearFieldError('last_name')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.phone" :label="$t('base.phone')" :hint="errorMessage('phone')"
                :invalid="!!errorMessage('phone')" @input="clearFieldError('phone')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.company_name" :label="'Назва організації'" :hint="errorMessage('company_name')"
                :invalid="!!errorMessage('company_name')" @input="clearFieldError('company_name')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-select-r v-model="form.profile.group" :options="countries" :label="$t('base.country')"
                :hint="errorMessage('group')" :invalid="!!errorMessage('group')" :loading="loadingCountries"
                item-text="name" item-value="id" @input="clearFieldError('group')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-card-actions class="justify-end">
                <v-btn color="green darken-1" dark @click="submit" :loading="loading">
                  {{ $t('base.save') }}
                </v-btn>
              </v-card-actions>
            </div>
          </div>


        </div>

      </div>
    </v-card-content>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import api from '@/api'

export default {
  name: 'EditClientModal',
  mixins: [formErrorsMixin],

  props: {
    client: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      loadingCountries: false,

      form: {
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        phone: '',
        user_type: 'client',
        company_name: '',
        profile: {
          group: null,
        },

      },
      errors: null,
      languages: [
        { id: 0, name: 'Українська', key: 'uk' },
        { id: 1, name: 'Русский', key: 'ru' },
        { id: 2, name: 'Polski', key: 'pl' },
        { id: 3, name: 'English', key: 'en' },
        { id: 4, name: 'Eesti', key: 'et' },
        { id: 5, name: 'Ελληνικά', key: 'el' },
        { id: 6, name: 'Español', key: 'es' },
        { id: 7, name: 'Español (US)', key: 'es-us' },
        { id: 8, name: 'Netherlands', key: 'nl' },
        { id: 9, name: 'Deutsch', key: 'de' },
        { id: 10, name: 'Français', key: 'fr' },
        { id: 11, name: 'Italiano', key: 'it' },
        { id: 12, name: 'Română', key: 'ro' },
        { id: 13, name: 'USA', key: 'us' },
      ],
    }
  },

  computed: {
    ...mapGetters('countriesGroups', ['countriesGroups']),

    countries () {
      if (!this.countriesGroups.length) {
        return []
      }
      return this.countriesGroups.map(country => ({
        id: country.id,
        name: country.name
      }))
    }
  },

  async mounted () {
    await this.loadCountries()
    this.fillForm()
  },

  methods: {
    ...mapActions('countriesGroups', ['loadCountriesGroups']),

    async loadCountries () {
      this.loadingCountries = true
      try {
        await this.loadCountriesGroups()
      } catch (error) {
        console.error('Помилка завантаження країн:', error)
      } finally {
        this.loadingCountries = false
      }
    },

    async fillForm () {
      this.form = {
        email: this.client.email || '',
        first_name: this.client.first_name || '',
        last_name: this.client.last_name || '',
        phone: this.client.phone || '',
        company_name: this.client.display_name || this.client.company_name || '',
        profile: {
          group: this.client.group,
        },

      }
    },

    clearFieldError (fieldName) {
      if (this.errors && this.errors[fieldName]) {
        this.$set(this.errors, fieldName, null)
      }
    },

    validate () {
      this.errors = {}

      if (!this.form.first_name) {
        this.errors.first_name = ['3']
      }

      if (!this.form.last_name) {
        this.errors.last_name = ['3']
      }

      if (!this.form.phone) {
        this.errors.phone = ['3']
      }

      if (!this.form.email) {
        this.errors.email = ['3']
      }

      if (!this.form.company_name) {
        this.errors.company_name = ['3']
      }



      if (!this.form.profile.group) {
        this.errors.group = ['3']
      }

      // Повертаємо true якщо немає помилок
      return Object.keys(this.errors).length === 0
    },

    async submit () {
      if (!this.validate()) return

      this.loading = true

      try {
        const payload = {
          email: this.form.email,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          phone: this.form.phone,
          user_type: this.form.user_type,
          display_name: this.form.company_name,
          profile: {
            group: this.form.profile.group
          }
        }



        const { errors } = await api.account.update(payload)

        if (!errors) {
          this.$toasted.success('Клієнта успішно оновлено!')
          this.$emit('update')
          this.$emit('close')
        } else {
          // Встановлюємо помилки з сервера
          this.errors = errors

          // Показуємо загальні повідомлення
          if (errors.email) {
            this.$toasted.error('Некоректний email!')
          } else if (errors.phone) {
            this.$toasted.error('Некоректний номер телефону!')
          } else if (errors.password) {
            this.$toasted.error('Некоректний пароль!')
          } else {
            this.$toasted.error('Сталася помилка при оновленні клієнта!')
          }
        }
      } catch (err) {
        console.error('Помилка при збереженні:', err)
        this.$toasted.error('Помилка при збереженні')
      } finally {
        this.loading = false
      }
    }
  },

  watch: {
    client: {
      handler () {
        if (this.client) {
          this.fillForm()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.v-card__actions {
  padding: 0;
  width: 100%;
}

.v-card__actions .v-btn {
  width: 100%;
}

.v-card__content {
  margin-top: 2rem;
  border-top: .1rem solid #d7d7d7;
  padding: 2rem;
  padding-top: 4rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.form-row {
  display: flex;
  gap: 40px;
  width: 100%;
}

.form-column {
  flex: 1;
  min-width: 0;
}

.form-element {
  width: 100%;
}

.access-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>